import { literal, nativeEnum, number, object, string } from 'zod';

import { IS_POSITIVE, IS_REQUIRED } from '@occc-app/lib/constants/validationMessages';
import { withIsEnabled } from '@occc/validation';

import { LimitTimePeriod } from '../../types';

export const LimitEnabledSchema = object({
  id: string().optional(),
  limit: number({ required_error: IS_REQUIRED }).gt(0, { message: IS_POSITIVE }),
  timePeriod: nativeEnum(LimitTimePeriod, { required_error: IS_REQUIRED }),
});

export const LimitDisabledSchema = object({
  id: string().optional(),
  limit: number().optional(),
  timePeriod: nativeEnum(LimitTimePeriod).optional().default(LimitTimePeriod.Total),
});

export const LimitDisabledSchemaWithIsEnabled = LimitDisabledSchema.extend({
  isEnabled: literal(false).default(false),
});

export const LimitSchema = withIsEnabled(LimitEnabledSchema, LimitDisabledSchema);
